module.exports = __webpack_public_path__ + "static/media/enact_policies_mobile.dd0e3ece.mp4";